
<div mat-dialog-content >
  <div class="flex justify-center items-center h-48 w-72">
    <div
      class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-28 w-28 "
    ></div>
  </div>
  <h1 class="text-center">Cargando</h1>  
</div>
<!-- <div mat-dialog-actions>

</div> -->